module.exports = __webpack_public_path__ + "static/img/next-page-disabled.d73b4dd9.svg";